import { Component, OnInit } from '@angular/core';
import { EmployeeDashboardService } from '../../services/eb-enrollee-dashboard/enrollee-dashboard.service';
import { EBDashboardMemberVm } from '../../models/eb-dashboard-member-vm';
import { EBDashboardProductVm } from '../../models/eb-dashboard-member-product-vm';
import { EBDashboardBenefitDetailsVm } from '../../models/eb-dashboard-benefit-details-vm';
import { EBDashboardBenefitDetailsRequest } from '../../models/eb-dashboard-member-benefit-details-request-vm';
import { Chart } from 'chart.js';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-eb-dashboard-member-and-benefit',
  templateUrl: './eb-dashboard-member-and-benefit.component.html',
  styleUrls: ['./eb-dashboard-member-and-benefit.component.scss']
})
export class EBDashboardMemberAndBenefitComponent implements OnInit {
  members: EBDashboardMemberVm[]
  productBenefitDetails: EBDashboardBenefitDetailsVm = null
  memberProducts: EBDashboardProductVm[]
  selectedMember: EBDashboardMemberVm = null
  selectedMemberProduct: EBDashboardProductVm = null
  productIdFromRoute: number
  backgroundColors = [
    '#1f78b4', '#33a02c', '#ff7f00', '#6a3d9a', '#b15928',
    '#a6cee3', '#b2df8a', '#fb9a99', '#fdbf6f', '#cab2d6',
    '#ffff99', '#8da0cb', '#66c2a5', '#ffd92f', '#e31a1c',
  ]

  chart: any = null

  constructor(private employeeDashboardService: EmployeeDashboardService,
    private messageService: MessageService,
    public route: ActivatedRoute) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.productIdFromRoute = Number(params.get('productId'));
    });
    this.employeeDashboardService.getAllActiveMembersByEnrolId().subscribe(
      (res: EBDashboardMemberVm[]) => {
        this.members = res
      }, error => {
        this.messageService.show(error.error.message, 'warning')
      }
    )
  }

  selectMember(member: EBDashboardMemberVm) {
    if (member.isEnrol == true) {
      this.employeeDashboardService.getAllActiveEnrolProductsByEnrolId().subscribe(
        (res: EBDashboardProductVm[]) => {
          this.selectedMemberProduct = null
          this.productBenefitDetails = null
          this.memberProducts = res
          if (this.memberProducts != null || this.memberProducts.length > 0) {
            if (this.productIdFromRoute) {
              let memberProd = this.memberProducts.filter(x => x.productId == this.productIdFromRoute)[0]
              this.productIdFromRoute = 0
              this.selectMemberProduct(memberProd)
            }
            else {
              this.selectMemberProduct(this.memberProducts[0])
            }
          }
        }, error => {
          this.messageService.show(error.error.message, 'warning')
          this.memberProducts = null
        }
      )
    }
    else if (member.isDependent == true) {
      this.employeeDashboardService.getAllActiveDependentProductsByEnrolDependentId(member.enrolDependentId).subscribe(
        (res: EBDashboardProductVm[]) => {
          this.selectedMemberProduct = null
          this.productBenefitDetails = null
          this.memberProducts = res
          if (this.memberProducts != null || this.memberProducts.length > 0) {
            this.selectMemberProduct(this.memberProducts[0])
          }
        }, error => {
          this.messageService.show(error.error.message, 'warning')
          this.memberProducts = null
        }
      )
    }

    this.selectedMember = member
  }

  selectMemberProduct(memberProduct: EBDashboardProductVm) {
    if (memberProduct) {
      let requestData: EBDashboardBenefitDetailsRequest = <EBDashboardBenefitDetailsRequest>{}
      requestData.memberProductId = this.selectedMember.isEnrol ? memberProduct.enrolProductId
        : memberProduct.enrollDependentProductId,
        requestData.enrolLatestSalary = this.selectedMember.enrolLatestSalary
      requestData.isEnrol = this.selectedMember.isEnrol
      requestData.groupPolicyId = this.selectedMember.groupPolicyId
      requestData.groupPolicyClusterProductId = memberProduct.groupPolicyClusterProductId
      requestData.claimTypePrefixNumber = memberProduct.claimTypePrefixNumber
      requestData.memberProductCode = memberProduct.productCode

      this.employeeDashboardService.getAllActiveMemberProductBenefitDetails(requestData).subscribe(
        (res: EBDashboardBenefitDetailsVm) => {
          this.productBenefitDetails = null
          this.selectMemberProductBenefits(res)
        }, error => {
          this.messageService.show(error.error.message, 'warning')
        }
      )
    }
    this.selectedMemberProduct = memberProduct
  }

  selectMemberProductBenefits(productBenefitDetails: EBDashboardBenefitDetailsVm) {
    this.productBenefitDetails = productBenefitDetails
    this.createChart()
  }

  createChart() {
    if (this.chart) {
      this.chart.destroy()
    }
    if (this.productBenefitDetails && this.productBenefitDetails.benefits) {
      let amounts = this.productBenefitDetails.benefits.map(x => x.benefitAmount)
      let benefitNames = this.productBenefitDetails.benefits.map(x => x.benefitName)
      if (amounts && benefitNames) {
        this.chart = new Chart("benefitChart", {
          type: 'pie',
          data: {
            labels: benefitNames,
            datasets: [{
              data: amounts,
              backgroundColor: this.backgroundColors,
            }],
          },
          options: {
            legend: {
              display: false
            },
          }
        });
      }
    }
  }
}
